<template>
	<Fragment>
		<BaseColumn class="w-128">
			<div class="flex items-center">
				<div class="mr-4 w-8 flex justify-center">
					<font-awesome-icon :icon="['fas', icon]" size="2x" />
				</div>

				<div class="ml-4 text-left">
					<div class="text-md leading-5 font-medium text-gray-900 font-bold">{{ value }}</div>
					<div class="text-md leading-5 text-gray-500">{{ subValue }}</div>
				</div>
			</div>
		</BaseColumn>
	</Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment';
import BaseColumn from '@/components/columns/BaseColumn';
export default {
	name: 'PrefixIconColumn',
	components: { BaseColumn, Fragment },
	props: {
		icon: {},
		value: {},
		subValue: {},
	},
};
</script>

<style scoped></style>
